import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
// import 'normalize.css/normalize.css'
import ElementUI from 'element-ui'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Vant)
import { api, axios } from './api'
Vue.prototype.$api = api
Vue.prototype.$axios = axios

import lodash from 'lodash'
Vue.prototype._ = lodash

import dayjs from 'dayjs'
Vue.prototype.$dayjs = dayjs

import util from './util/index'
Vue.use(util)

import cookies from 'vue-cookies'
Vue.use(cookies)

import meta from 'vue-meta'
Vue.use(meta)
Vue.use(ElementUI, {
    // locale
})

// import BMap from 'vue-baidu-map'
// Vue.use(BMap, {
//     // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//     ak: 'QSlkQ2sk6Fxz49XBgP3GRHhky9ospK8O'
// })
// 全局组件自动注册
import '@/components/autoRegister'

// 自动加载 svg 图标
const req = require.context('./assets/icons', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
